﻿/* 
Object:         PeriodPartSelectionEnum
Used in:        Report Module
*/

window.PeriodPartSelectionEnum = {};

Object.defineProperties(window.PeriodPartSelectionEnum, {
    FullPeriod: { value: 0, writable: false },
    OnlyWorkDays: { value: 1, writable: false },
    OnlyWeekend: { value: 2, writable: false }
});

Object.freeze(window.PeriodPartSelectionEnum);
